import { ICoverageShiftResponse } from 'types/api/coverageApi.interface'

export const coverageTone = (input: {
  required: number
  covered: number
  criticalGap: boolean
}): 'success' | 'warning' | 'danger' | 'neutral' => {
  if (!input.required) return 'neutral'
  const ratio = input.covered / input.required
  if (input.criticalGap || ratio < 0.75) return 'danger'
  if (ratio < 1) return 'warning'
  return 'success'
}

export const coverageBarPct = (covered: number, required: number) =>
  required ? Math.min(Math.round((covered / required) * 100), 100) : 0

export const coverageStatusTone = (status: number): 'success' | 'warning' | 'danger' =>
  status === 3 ? 'danger' : status === 2 ? 'warning' : 'success'

export const coveragePhaseKey = (phase: number): 'future' | 'active' | 'past' =>
  phase === 1 ? 'future' : phase === 2 ? 'active' : 'past'

export const minToHHMM = (totalMin: number): string => {
  const m = ((totalMin % 1440) + 1440) % 1440
  return `${String(Math.floor(m / 60)).padStart(2, '0')}:${String(m % 60).padStart(2, '0')}`
}

export const shiftWindowFrom = (shift: ICoverageShiftResponse): string => minToHHMM(shift.shiftStart)

export const shiftWindowTo = (shift: ICoverageShiftResponse): string =>
  minToHHMM(shift.shiftStart + shift.minutes)
